import React from 'react';
import { LangContext } from '../../contexts/LangContext';
import './LoyaltyHistory.css';

function formatDate(dateStr, locale) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  return d.toLocaleDateString(locale);
}

// Combina purchases de weekly e monthly numa lista única por (data+pacote).
// Compras que aparecem nas duas edições ficam na mesma linha.
function mergeRows(weeklyPurchases = [], monthlyPurchases = []) {
  const map = new Map();

  weeklyPurchases.forEach(p => {
    const key = `${p.purchaseDate}|${p.packageNameEng}`;
    map.set(key, { ...p, weeklyPoints: p.pointsEarned, monthlyPoints: null });
  });

  monthlyPurchases.forEach(p => {
    const key = `${p.purchaseDate}|${p.packageNameEng}`;
    if (map.has(key)) {
      map.get(key).monthlyPoints = p.pointsEarned;
    } else {
      map.set(key, { ...p, weeklyPoints: null, monthlyPoints: p.pointsEarned });
    }
  });

  return [...map.values()].sort((a, b) => new Date(b.purchaseDate) - new Date(a.purchaseDate));
}

export default function LoyaltyHistory({ loyaltyData, onClose }) {
  const { lang, t } = React.useContext(LangContext);
  const lh = t.component.loyaltyHistory;
  const locale = lang === 'USD' ? 'en-US' : 'pt-BR';

  const activeEditions  = loyaltyData?.activeEditions ?? [];
  const weekly  = activeEditions.find(e => e.type === 'weekly');
  const monthly = activeEditions.find(e => e.type === 'monthly');
  const rows = mergeRows(weekly?.purchases, monthly?.purchases);

  return (
    <div className="loyalty-history-overlay" onClick={onClose}>
      <div className="loyalty-history-modal" onClick={(e) => e.stopPropagation()}>
        <div className="loyalty-history-header">
          <span className="header-title">{lh.title}</span>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="loyalty-history-body">
          <table className="loyalty-history-table">
            <thead>
              <tr className="loyalty-history-thead">
                <th className="th th-data">{lh.date}</th>
                <th className="th">{lh.pack}</th>
                <th className="th th-pontos">{lh.pointsEarnedWeekly}</th>
                <th className="th th-pontos">{lh.pointsEarnedMonthly}</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td className="td" colSpan={4} style={{ textAlign: 'center', opacity: 0.6 }}>—</td>
                </tr>
              ) : rows.map((row, i) => (
                <tr key={i} className={i % 2 === 0 ? 'row-even' : 'row-odd'}>
                  <td className="td">{formatDate(row.purchaseDate, locale)}</td>
                  <td className="td">{lang === 'USD' ? row.packageNameEng : row.packageNamePt}</td>
                  <td className="td">{row.weeklyPoints ?? '—'}</td>
                  <td className="td">{row.monthlyPoints ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
